<div class="grid grid-no-password">
    <div id='no-password-header'>{{trans('auth.titles.noPasswordSet')}}</div>
    <div id='no-password-description'>{{trans('auth.activation.noPasswordSet')}}</div>
    <div id='no-password-button' class="button" (click)='resetClick()'>{{trans('auth.buttons.resetPassword')}}</div>
</div>
